export const messages = {
  en: {
    adminRoom: {
      search: {
        title: 'Search Conditions',
        roomNum: 'Room Number Building-Unit-Room',
        ownerName: 'Owner Name',
        ownerTel: 'Owner Phone',
        state: 'Select State',
        roomType: 'Select Room Type'
      },
      page: {
        title: 'Community Rooms',
        subtitle: 'Browse room, owner and contract information by building tree',
        empty: 'No room data found for the current selection',
        loadFailed: 'Failed to load room data, please retry',
        tip: 'Select a community, floor or unit in the left tree to narrow down the results',
        scopeCommunity: 'Community scope',
        scopeFloor: 'Floor scope',
        scopeUnit: 'Unit scope'
      },
      list: {
        title: 'Community Rooms'
      },
      tree: {
        title: 'Building Tree'
      },
      table: {
        room: 'Room',
        community: 'Community',
        floor: 'Floor',
        floorUnit: 'F',
        owner: 'Owner',
        type: 'Type',
        area: 'Area',
        areaUnit: 'm²',
        rent: 'Rent',
        state: 'State',
        validDate: 'Valid Date',
        member: 'Member',
        car: 'Car',
        ownerRoom: 'Owner Room',
        contract: 'Contract'
      },
      fetchError: 'Failed to fetch room data'
    }
  },
  zh: {
    adminRoom: {
      search: {
        title: '查询条件',
        roomNum: '房屋编号 楼栋-单元-房号',
        ownerName: '业主名称',
        ownerTel: '业主电话',
        state: '请选择状态',
        roomType: '请选择房屋类型'
      },
      page: {
        title: '小区房屋',
        subtitle: '按楼栋树浏览房屋、业主与合同信息',
        empty: '当前选择范围内暂无房屋数据',
        loadFailed: '房屋数据加载失败，请重试',
        tip: '在左侧树中选择小区、楼层或单元可缩小查询范围',
        scopeCommunity: '当前范围：小区',
        scopeFloor: '当前范围：楼层',
        scopeUnit: '当前范围：单元'
      },
      list: {
        title: '小区房屋'
      },
      tree: {
        title: '楼栋树'
      },
      table: {
        room: '房屋',
        community: '小区',
        floor: '楼层',
        floorUnit: '层',
        owner: '业主',
        type: '类型',
        area: '建筑/室内面积',
        areaUnit: '平方米',
        rent: '租金',
        state: '房屋状态',
        validDate: '有效期',
        member: '业主成员',
        car: '业主车辆',
        ownerRoom: '业主房屋',
        contract: '房屋合同'
      },
      fetchError: '获取房屋数据失败'
    }
  }
}